/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Project_Overview_Chip1_LabelInputs */



/**
* | output |
* | --- |
* | "When should I create a new project?" |
*
* @param {Uno_Edu_Project_Overview_Chip1_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_project_overview_chip1_label = /** @type {((inputs?: Uno_Edu_Project_Overview_Chip1_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Project_Overview_Chip1_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wann sollte ich ein neues Projekt erstellen?")
	return /** @type {LocalizedString} */ ("When should I create a new project?")
});